import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useLayoutEffect, useState } from "react";
/**
 * Custom collapse component that animates height transitions.
 * Replaces react-collapse to avoid React 18 type conflicts.
 */
export const Collapse = ({ isOpened, children, duration = 400, disableAnimation = false, }) => {
    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);
    // Measure content height and observe resize (images, async data, child state changes)
    useLayoutEffect(() => {
        const el = contentRef.current;
        if (!el)
            return;
        const updateHeight = () => setContentHeight(el.scrollHeight);
        updateHeight();
        if (isOpened) {
            const observer = new ResizeObserver(updateHeight);
            observer.observe(el);
            return () => observer.disconnect();
        }
    }, [isOpened]);
    // Skip transition on initial mount with isOpened=true: contentHeight starts at 0,
    // then useLayoutEffect measures and triggers re-render. Without this, the 0→height
    // change would be animated, causing an unwanted slide-down on mount.
    const skipTransition = disableAnimation || (isOpened && contentHeight === 0);
    // Legacy: disableAnimation used to apply height:auto !important, so content was always visible
    const effectiveOpened = disableAnimation ? true : isOpened;
    const style = {
        overflow: "hidden",
        transition: skipTransition ? "none" : `max-height ${duration}ms ease`,
        maxHeight: effectiveOpened ? `${contentHeight}px` : "0px",
    };
    return (_jsx("div", { style: style, className: "ReactCollapse--collapse", children: _jsx("div", { ref: contentRef, className: "ReactCollapse--content", children: children }) }));
};
